<template>
  <div id="CPIRateVerificationReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area" >
       <template v-if="cantAccessPage === true">
          <div class="page-name">
            <div class="page-title">CPI Rate Verification</div>
            <div class="web-action-btn btn-groups text-right">
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
          </div>
          <div class="container-fluid">
            <div class="admin-page-content contact-list">
               <data-table-filter-config :moduleName="'CPIRateVerificationReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                <div class="data-table bg-white overflow-hidden">
                    <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                    <section class="bg-white data-table">
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange" :moduleName="'CPIRateVerificationReport'" :position="'top'">
                        </custom-pagination>

                        <vue-good-table
                            ref="cpirateverificationreportTable"
                            mode="remote"
                            title="CPI Rate Verification Report"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            :totalRows="totalRecords"
                            :columns="userColumns"
                            :rows="rows"
                            :isLoading=false
                            :paginationOptions="{
                                enabled: false,
                                position: 'both',
                                perPage: perPage,
                                dropdownAllowAll: false,
                                setCurrentPage:listCurrentPage,
                                perPageDropdown:dropDownPerPage,
                            }"
                            :search-options="{
                            enabled: false,
                            }"
                            :sort-options="{
                            enabled: true,
                            }">
                        </vue-good-table>
                        <custom-pagination
                            :page-changed="onPageChange"
                            :per-page-changed="onPerPageChange">
                        </custom-pagination>
                    </section>
                </div>

            </div>
          </div>
       </template>
       <template v-else-if="cantAccessPage === false">
          <div class="container-fluid">
              <div class="bg-white text-center">
                  <h1>
                      Oops!</h1>
                  <h2>
                      403 </h2>
                  <div class="error-details">
                      Sorry!, You don't have permission to access this page.
                  </div>
              </div>
          </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
  name: "CpiRateVerificationReport",
  metaInfo() {
    return {title: "CPI Rate Verification | " +process.env.COPYRIGHT_NAME}
  },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
      cantAccessPage:"",
      loading: false,
      pageTitle:'CPI Rate Verification',
      permissions:[],
      rows: [],
      totalRecords: 0,
      userColumns:[],
      columns:[
        {
            label: "Customer Name",
            field: "customer_name",
            fpFieldType:"text",
            filterable: true,
            hidden:false,
        },
        {
            label: "Customer Nbr",
            field: "cust_code",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Suffix",
            field: "customer_suffix",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Customer Suffix", // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: ['000','001','002'], // dropdown (with selected values) instead of text input
                trigger: "enter" //only trigger on enter not on keyup
            },
            sortable: false
        },
        {
            label: 'Agmt Header',
            field: 'agreement_header',
            hidden:false,
            fpFieldType:"option",
            filterable: true,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "All", // placeholder for filter input
                filterDropdownItems: ['LC'],
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            },
            sortable: false
        },
        {
            label: 'Contract Type',
            field: 'conType',
            fpFieldType:"option",
            filterable: true,
            hidden:false,

        },
        {
            label: 'Agmt Number',
            field: 'agreement_no',
            // sortable: false,
            hidden:false,
            filterable: true,
            fpFieldType:"text",
        },
        {
            label: 'Unit',
            field: 'unit_no',
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Unit No.", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'Start Date',
            field: 'start_date',
            fpFieldType:"custom_date",
            html: false,
            filterable: true,
            hidden:false,

        },
        {
            label: 'Contract Status',
            field: 'status',
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Contract Status", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: ['Active'],
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: 'CPI Code',
            field: 'cpi_code',
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "CPI Code", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Base Index Date",
            field: 'base_index',
            fpFieldType:"date",
            filterable: false,
            hidden:false
        },
        {
            label: "CPI Value",
            field: 'cpi_value',
            hidden:false,
            fpFieldType:"text",
            filterable: false
        },
        {
            label: "CPI Frequency",
            field: 'cpi_frequency',
            hidden:false,
            fpFieldType:"text",
            filterable: false,
            sortable: false
        },
        {
            label: 'Section',
            field: 'section',
            hidden:false,
            fpFieldType:"option",
            filterable: false,
            // filterOptions: {
            //     enabled: false, // enable filter for this column
            //     placeholder: "Section", // placeholder for filter input
            //     filterValue: '', // initial populated value for this filter
            //     filterDropdownItems: [], // dropdown (with selected values) instead of text input
            //     filterFn: this.onColumnFilter, //custom filter function that
            //     trigger: "enter" //only trigger on enter not on keyup
            // }
        },
        {
            label: "CPI Option",
            field: 'cpi_option',
            hidden:false,
            fpFieldType:"text",
            filterable: false,
            sortable: false
        },
        {
            label: "CPI Anniversary Point",
            field: 'cpi_anniversary_point',
            hidden:false,
            fpFieldType:"text",
            filterable: false,
            sortable: false
        },
        {
            label: 'First CPI Esc Date',
            field: 'first_cpi_esc_date',
            fpFieldType:"date",
            filterable: false,
            hidden:false
        },
      ],
      action:'list',
      batchProcess:0,
      batchNum:"",

  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'cpi_rate_verification_report') {
                self.cantAccessPage = true;
            }
            if(self.cantAccessPage == ''){
                self.cantAccessPage = false;
            }
        });
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  created: function() {
      this.serverParams.stopRequest = true;
  },
  methods:{
    cancelAll: function (cancelAll) {
        this.$refs.subDayPeriodTable.unselectAllInternal();
    },
    loadList: function(){
      var self = this;
      self.loading = true;

      var date = new Date();
      var offset = date.getTimezoneOffset();
      $.ajax({
        url: process.env.ROOT_API + "/cpi-rate-verification-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action
        },
        success: function(data) {
          self.loading = false;

          if (data.status == "success") {
            if ( self.action == "export" ||  self.action == "export_queue") {
                if ( data.code == "201" ) {
                    alert(data.message);
                } else {
                    if ( self.action == "export" ) {
                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    } else {
                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }
                }
                self.action = "list";
                // self.loadList();

            } else {
               if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }


          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'fuel-inventory-clearing-Summary')
        }
      });

    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/CpiRateVerificationReport.vue